import { render, staticRenderFns } from "./GemIcon.vue?vue&type=template&id=7c3ec93b&"
import script from "./GemIcon.vue?vue&type=script&lang=js&"
export * from "./GemIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports